import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';

type JsonViewProps = {
  data: unknown;
  depth?: number;
};

export const JsonView = (props: JsonViewProps) => {
  const { data, depth } = props;

  if (!data) {
    return null;
  }

  if (typeof data !== 'object') {
    return <TextV2 marginLeft="1rem">{data.toString()}</TextV2>;
  }

  if (Array.isArray(data) && typeof data[0] === 'string') {
    return (
      <Flex overflow="wrap">
        {data.map((element, index) => {
          return (
            <JsonView
              data={element}
              key={index}
            />
          );
        })}
      </Flex>
    );
  }

  const pairs = Object.entries(data);

  return (
    <Flex
      flexDirection="column"
      marginLeft="1rem"
    >
      {pairs.map((pair, index) => {
        return (
          <Flex
            flexDirection="column"
            gap="0.5rem"
            key={index}
            borderLeft="1px solid black"
            paddingLeft="0.5rem"
          >
            <TextV2 typographyVariant="hed3">{pair[0]}</TextV2>
            <JsonView
              data={pair[1]}
              depth={(depth ?? 0) + 1}
            ></JsonView>
          </Flex>
        );
      })}
    </Flex>
  );
};
